module.exports = __webpack_public_path__ + "static/media/order-history.e69084cb.png";